// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".handle-br{display:block!important;bottom:0!important;right:0!important}.handle{width:16px!important;height:16px!important;z-index:26!important;border:none!important;background:repeating-linear-gradient(-45deg,#d3d3d3,#d3d3d3 3px,#a9a9a9 0,#a9a9a9 5px)!important}@media only screen and (max-width:768px){.handle-br{display:none!important}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
